var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding-top":"0px !important","height":"60px"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('Snackbar'),_c('NotificationRevision',{ref:"notification"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }